module.exports = __webpack_public_path__ + "static/media/movie-cargo.f9288fcd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/movies/movie-cargo.jpg
// module id = 33
// module chunks = 0